<template>
  <div class="subscription-card" :class="type.toLowerCase()">
    <div v-if="isCurrentPlan" class="current-plan-banner">
      {{ $t('subscription.currentPlan') }}
    </div>
    <h3 class="card-title">{{ formattedType }}</h3>
    <div class="card-description" v-if="description">
      <p>{{ description }}</p>
    </div>

    <ul class="features">
      <li v-for="(feature, index) in features" :key="index">
        <component :is="feature.icon" class="mr-2"></component>
        {{ feature.text }}
      </li>
    </ul>

    <div
      v-if="isCurrentPlan && ((currentMaxNbOperations && currentMaxNbOperations > operationsPerYear) || (currentMaxNbCollaborators && currentMaxNbCollaborators > collaboratorsPerYear))"
      class="subscribed-options"
    >
      <p class="options-title">{{ $t('subscription.optionsSubscribed') }}</p>
      <ul class="option-list ml-3">
        <li v-if="currentMaxNbOperations > operationsPerYear" class="option-item">
          <span>{{ $t('subscription.option1.count', {count : currentMaxNbOperations - operationsPerYear }) }}</span>
        </li>
        <li v-if="currentMaxNbCollaborators > collaboratorsPerYear" class="option-item">
          <span>{{ $t('subscription.option2.count',{count : currentMaxNbCollaborators - collaboratorsPerYear }) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>



<script>
export default {
  name: 'SubscriptionCard',
  props: {
    type: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    operationsPerYear: {
      type: Number,
      required: true
    },
    collaboratorsPerYear: {
      type: Number,
      required: true
    },
    btnActionText: {
      type: String,
      default: 'Souscrire'
    },
    isCurrentPlan: {
      type: Boolean,
      default: false
    },
    currentMaxNbOperations: {
      type: Number,
      default: 0
    },
    currentMaxNbCollaborators: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      icons: {
        operations: 'building-community-icon',
        collaborators: 'users-icon',
      }
    };
  },
  computed: {

    formattedType() {
      return this.type.charAt(0).toUpperCase() + this.type.slice(1).toLowerCase();
    },

    features() {
      return [
        {
          icon: this.icons.operations,
          text: `${this.operationsPerYear} Opérations / an`
        },
        {
          icon: this.icons.collaborators,
          text: `${this.collaboratorsPerYear} Collaborateurs MDB / an`
        }
      ];
    }
  }
};
</script>

<style scoped>
.subscription-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative; /* Nécessaire pour positionner le bandeau */
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subscription-card:hover {
  transform: translateY(-4px);
}
.subscribed-options ul {
  margin: 8px 0;
  padding-left: 16px;
}
.subscribed-options li {
  font-size: 14px;
}


.current-plan-banner {
  position: absolute;
  top: -15px; /* Décalage pour le chevauchement vertical */
  right: 10px; /* Décalage pour le chevauchement horizontal */
  width: auto; /* Laisse la largeur s'adapter au contenu */
  height: auto; /* S'adapte également au contenu */
  background: var(--main-red); /* Rouge pour le bandeau */
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  padding: 8px 16px; /* Ajoute un padding pour un style agréable */
  border-radius: 4px; /* Ajoute des coins légèrement arrondis */
  z-index: 2;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2); /* Ajoute une ombre pour le contraste */
}


.card-title {
  font-size: 24px;
  font-weight: bold;
}

.card-description {
  font-size: 14px;
}

.features {
  list-style: none;
  padding: 0;
  margin: 8px 0;
}

.features li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.feature-icon {
}

.subscription-button {
  background: #c41e3a;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.subscription-button:hover {
  background: #a01830;
}

/* Variantes par type */
.starter {
  background: #f8f9fa;
}

.pro {
  background: rgb(109,132,196);
  color: white;
}

.expert {
  background: rgb(7,21,60);
  color: white;
}

.expert .card-title,
.expert .amount {
  color: white;
}

.expert .subscription-button {
  background: #c41e3a;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/SubscriptionCard.vue